"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var AppPaySystemWalletLockAmountsList_1 = require("./AppPaySystemWalletLockAmountsList");
var AppPaySystemWalletReceivesList_1 = require("./AppPaySystemWalletReceivesList");
var AppPaySystemWalletOperationsConfig = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletOperationsConfig, _super);
    function AppPaySystemWalletOperationsConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_locked_amounts = "locked.amounts";
        _this.tab_receive_amounts = "receive.amounts";
        return _this;
    }
    AppPaySystemWalletOperationsConfig.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                locks_page_size: data.tablePageSize,
                receives_page_size: data.tablePageSize
            });
        });
        this.setState({
            WalletLocksMode: "LIST",
            WalletLocksRecord: null,
            WalletReceiveMode: "LIST",
            WalletReceiveRecord: null,
            locks_page_num: 1,
            locks_page_size: this.props.state.getTablePageSize(),
            receives_page_num: 1,
            receives_page_size: this.props.state.getTablePageSize(),
        });
        this.props.state.setExtBreadCrumbPath(["Свойства кошелька"]);
    };
    AppPaySystemWalletOperationsConfig.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    AppPaySystemWalletOperationsConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    AppPaySystemWalletOperationsConfig.prototype.onPageLocksConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ locks_page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    AppPaySystemWalletOperationsConfig.prototype.onPageReceiveConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ receives_page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    AppPaySystemWalletOperationsConfig.prototype.getLockAmountsObject = function () {
        return (React.createElement(AppPaySystemWalletLockAmountsList_1.default, { state: this.props.state, data: this.props.dataWalletLocks, onGoBackClick: this.backToRootClick.bind(this), root: this.props.record, pageNum: this.state.locks_page_num, pageSize: this.state.locks_page_size, onPageConfigChanged: this.onPageLocksConfigChange.bind(this) }));
    };
    AppPaySystemWalletOperationsConfig.prototype.getReceiveAmountObject = function () {
        return (React.createElement(AppPaySystemWalletReceivesList_1.default, { state: this.props.state, data: this.props.dataWalletReceives, root: this.props.record, pageNum: this.state.receives_page_num, pageSize: this.state.receives_page_size, onPageConfigChanged: this.onPageReceiveConfigChange.bind(this), onGoBackClick: this.backToRootClick.bind(this) }));
    };
    AppPaySystemWalletOperationsConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_locked_amounts },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "coin" }),
                        "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u0443\u043C\u043C\u044B"), key: this.tab_locked_amounts }, this.getLockAmountsObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                        "\u041F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u043A\u043E\u0448\u0435\u043B\u0435\u043A"), key: this.tab_receive_amounts }, this.getReceiveAmountObject()))));
    };
    return AppPaySystemWalletOperationsConfig;
}(React.Component));
exports.default = AppPaySystemWalletOperationsConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ui/component/AppPaySystemWalletOperationsConfig.tsx
// module id = 2565
// module chunks = 0